import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Aside from '../components/Aside';
import Header from '../components/Header';
import { getRoutes } from '../constants/Routes';
import useAuth from '../hooks/useAuth';
import { isAdmin, isManager, isStaff, isSuperAdmin } from '../helper';
import { getUsers } from '../redux/actions/auth';
import { handleLogout } from '../utils';
import useRestaurants from '../hooks/useRestaurants';

const PrivateRoute = () => {
  const { token, user } = useAuth();
  const { restaurants } = useRestaurants();

  useEffect(() => {
    if (token && user?.restaurants?.length) {
      getUsers();
    }
  }, [token, user?.restaurants]);

  useEffect(() => {
    if (token && user?.status === 0) {
      handleLogout();
    }
  }, []);

  if (!token) {
    return <Navigate to={getRoutes().login.route()} />;
  }

  return (
    <div className="Layout">
      <div className="Layout__Header">
        <Header />
      </div>
      <div className="Layout__Container">
        {(isSuperAdmin() || isAdmin() || isManager() || (isStaff() && restaurants?.length > 1)) && (
          <div className="Layout__Container__Aside">
            <Aside />
          </div>
        )}
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateRoute;
